import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Customer Details Cell Renderer
 *
 * Displays customer/business partner information with code and name in a two-line format.
 * Code is displayed in small gray monospace text, name in regular text.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'customer',
 *   headerName: 'Cliente',
 *   cellRenderer: CustomerDetailsCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-customer-details-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col text-sm whitespace-nowrap">
      <span class="table-text-code text-xs text-gray-500">
        {{ customerCode }}
      </span>
      <span>{{ customerName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .table-text-code {
      font-family: 'Courier New', monospace;
    }
  `]
})
export class CustomerDetailsCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get customerCode(): string {
    return this.params.data?.shipToExternalKeys ?? '-';
  }

  get customerName(): string {
    return this.params.data?.shipToName ?? '-';
  }
}
